import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
// Sprint 119.97 — NL 6è idioma. GSC 2026-08-12: NL amb 21 impressions/setmana
// i posició mitjana 5.86 (millor país no-ES). Mercat wellness maduro,
// EN 17645 aplica igualment. Norma NL: NEN-EN 17645.
import nl from './locales/nl.json';
import { langOfSlugPath } from '../config/routeSlugs';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  nl: { translation: nl }
};

export const SUPPORTED_LANGS = ['es', 'en', 'fr', 'de', 'it', 'nl'];

// ════════════════════════════════════════════════════════════════════
// Sprint 132 — L'URL determina l'idioma, no el navegador
// ════════════════════════════════════════════════════════════════════
// PROBLEMA que això resol (confirmat amb GSC "Ver página rastreada" el
// 26/08/2026 sobre /calculadoras):
//
//   L'ordre de detecció era ['localStorage', 'navigator']. Googlebot
//   renderitza amb navigator.language = 'en-US', així que:
//     · i18n.language = 'en-US'
//     · SEO.js emetia <html lang="en-US"> a una URL canònica castellana
//     · CalculadorasHub feia seoConfigs.calculators['en-US'] → undefined
//       → requeia al .es → títol en castellà
//   Resultat: la pàgina es declarava anglesa i servia text castellà, i
//   l'idioma depenia de la capçalera del visitant en lloc de la URL.
//   Google no pot establir el mapa URL↔idioma que necessita l'hreflang.
//
// SOLUCIÓ: un únic detector que llegeix el primer segment de la ruta.
//   /en/calculadoras  → en
//   /nl/blog/...      → nl
//   /calculadoras     → es   (sense prefix = canònica castellana)
//
// No cachegem a localStorage: si ho féssim, una preferència antiga
// guanyaria a la URL i tornaríem al mateix problema.
//
// Sprint 161 — Excepció: les seccions amb slug per idioma on l'idioma sense
// prefix NO és el castellà. /tools/pool-volume-calculator és l'anglesa (la
// castellana és /calculadora-volumen-piscina); sense això es renderitzava en
// castellà sota un títol i un hreflang que la declaren anglesa.
const urlPathDetector = {
  name: 'urlPath',
  lookup() {
    if (typeof window === 'undefined') return 'es';
    const seg = (window.location.pathname.split('/')[1] || '').toLowerCase();
    if (SUPPORTED_LANGS.includes(seg)) return seg;
    return langOfSlugPath(window.location.pathname) || 'es';
  },
  cacheUserLanguage() {
    // Intencionadament buit — la URL és l'única font de veritat.
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(urlPathDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Canviat d'"en" a "es": les rutes sense prefix són la canònica
    // castellana, així que el fallback natural és el castellà.
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGS,
    // Normalitza "en-US" → "en" perquè els lookups per codi curt
    // (seoConfigs[lang], etc.) no fallin mai.
    load: 'languageOnly',
    debug: false,
    // Sprint 118.4 va posar aquí `compatibilityJSON: 'v3'` per habilitar el
    // sufix _plural clàssic i arreglar "hace 2 día" → "hace 2 días".
    //
    // Sprint 148 — S'ha retirat perquè amb i18next 25 aquesta opció
    // S'IGNORA, i el bug havia tornat sense fer soroll: a producció es
    // llegia "en 3 país" i "hace 3 día". No falla ni avisa per consola;
    // simplement no troba la clau _plural i serveix la singular.
    //
    // Comprovat amb la versió instal·lada: n'hi ha prou amb la clau base
    // (que fa de singular) més el sufix _other. No cal cap més config, al
    // contrari del que deia el comentari anterior. Les 12 claus _plural
    // del projecte s'han migrat a _other.
    interpolation: {
      escapeValue: false
    },
    detection: {
      // Només la URL. Sense localStorage ni navigator: qualsevol dels dos
      // faria que la mateixa URL es rendéis en idiomes diferents segons
      // qui la visita, que és precisament el que trencava l'hreflang.
      order: ['urlPath'],
      caches: []
    }
  });

export default i18n;
